import { PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_CLIENT_ID!;
const tenantId = process.env.REACT_APP_TENANT_ID;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const authority = `https://login.microsoftonline.com/${tenantId}`;

const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

const msalInstance = new PublicClientApplication(msalConfig);
const scope = `api://${process.env.REACT_APP_CLIENT_ID}/${process.env.REACT_APP_API_SCOPE}`;

export default msalInstance;
export { scope };